<template>
  <!--//@*/*
    //    *RPD  App v0.91
    //    * Copyright (c) 2022, Blue Cover Six LLC .John Molt All rights reserved.
    //    Code licensed under contract To Reno Police Department / City of Reno, in perpetuity
    //    */
    //-->
  <div id="template_root" class="pb-6">
    <!-- DATA TABLE -->
    <template>
      <!-- <v-row>
        <v-col cols="12" md="" class="d-flex justify-start">
          <h1 class="ml-1">Sworn</h1>
          <v-btn class="accent ml-3 mr-1 mt-2" @click.prevent="open_dialog"
            >Add</v-btn
          >
          <div class="d-flex flex-column justify-end">
            <v-spacer></v-spacer>
            <h5 class="ml-3 mb-1">Displayed:{{ current_items.length }}</h5>
          </div>
          <v-spacer></v-spacer>
        </v-col>
      </v-row> -->
      <v-row no-gutters class="mt-2">
        <v-col cols="12" md="12" class="d-flex justify-end mt-4 mt-md-0">
          <v-btn
            :x-small="$vuetify.breakpoint.mobile"
            class="ml-2 accent"
            @click="assign_tests"
            title="Assign test to Displayed members"
            >Assign Test</v-btn
          >
          <v-btn
            :x-small="$vuetify.breakpoint.mobile"
            class="ml-2 accent"
            @click="email_cur_items"
            title="Send Email to Displayed members"
            >Email</v-btn
          >
          <v-btn
            :x-small="$vuetify.breakpoint.mobile"
            class="ml-2 mr-2 accent"
            title="Certify Displayed members, (When test passed, this is set automatically)"
            @click="certify_sworn"
            >Certify</v-btn
          >
          <v-btn
            :x-small="$vuetify.breakpoint.mobile"
            class="ml-2 mr-2 accent"
            title="Print Displayed members."
            @click="print"
            >Print</v-btn
          >
        </v-col>
      </v-row>
      <v-row no-gutters class="">
        <v-col cols="12" md="12" class="d-flex justify-start mt-4 mt-md-0">
          <h4 class="ml-1">Filters:</h4>
        </v-col>
        <v-col cols="12" md="12" class="d-flex justify-start mb-2">
          <v-btn-toggle
            active-class="btn-on"
            v-model="toggle_exclusive"
            mandatory
          >
            <v-btn
              x-small
              class="ml-2 mr-2 mt-2 ml-1 accent2 alice"
              @click="filter_change('none')"
              title="Show all members."
              >None</v-btn
            >
            <v-btn
              x-small
              class="mr-2 accent2 mt-2 ml-1 alice"
              @click="filter_change('certified')"
              title="Certified date not empty."
              >Certified</v-btn
            >
            <v-btn
              x-small
              class="mr-2 accent2 mt-2 ml-1 alice"
              @click="filter_change('this_month')"
              title="Expire date falls within the current month."
              >Due this month</v-btn
            >
            <v-btn
              x-small
              class="mr-2 accent2 mt-2 ml-1 alice"
              @click="filter_change('next_month')"
              title="Expire date falls within the next month."
              >Due next month</v-btn
            >
            <v-btn
              x-small
              class="mr-2 accent2 mt-2 ml-1 alice"
              @click="filter_change('assigned')"
              title="Status equals assigned."
              >Assigned</v-btn
            >
            <v-btn
              x-small
              class="mr-2 accent2 mt-2 ml-1 alice"
              @click="filter_change('expired')"
              title="Expired date has past."
              >Expired</v-btn
            >
            <v-btn
              x-small
              class="mr-2 accent2 mt-2 ml-1 alice"
              @click="filter_change('past_due')"
              title="Assigned date is older than two weeks."
              >Past Due</v-btn
            >

            <v-btn
              x-small
              class="mr-2 accent2 mt-2 ml-1 alice"
              @click="filter_change('alpha20')"
              title="Take Next 20 member whose Expired date has past and not Assigned."
              >Next Alpha 20</v-btn
            >
            <!-- //alpha20 -->

            <!-- <v-btn x-small class="mr-2 accent2 alice">Fail</v-btn> -->
          </v-btn-toggle>
        </v-col>
      </v-row>
      <v-card>
        <v-card-title>
          <v-row no-gutters class="d-flex justify-start mb-2">
            <v-col id="freak" md="1" style="max-width: 100px">
              <v-btn class="accent ml-3 mr-1 mt-2" @click.prevent="open_dialog"
                >Add</v-btn
              >
            </v-col>
            <v-col md="6">
              <v-text-field
                style="max-width: 600px"
                v-model="search"
                append-icon="mdi-magnify"
                label="Search"
                single-line
                hide-details
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-title>
        <v-data-table
          ref="my_table"
          :headers="headers"
          :items="members"
          :search="search"
          :footer-props="{
            'disable-items-per-page': true,
          }"
          @current-items="current_items_change"
        >
          <template v-slot:item.action1="{ item }">
            <v-btn
              class="px-0"
              x-small
              @click="edit_member(item)"
              color="accent"
            >
              Open
            </v-btn>
            <v-btn
              class="px-0 ml-2"
              x-small
              @click="remove_member_temp(item)"
              color="accent"
              >X
            </v-btn>
          </template>

          <!-- <template v-slot:item.action2="{ item }">
            <v-btn class="px-0" x-small @click="sendRequest(item)">
              Pprint
            </v-btn>
          </template> -->
        </v-data-table>
      </v-card>
    </template>
    <!-- new_member: {
        sworn_memberId: 0,
        last_name: "",
        first_name: "",
        email: "jvonmolt@gmail.com",
        rpd_number: "",
        division: "",
        status: "None",
        cert_date: "1/1/1900",
        exp_date: "1/1/1900",
        assigned: "1/1/1900",
      }, -->
    <!-- sworn add and edit -->
    <v-row justify="center">
      <v-dialog v-model="dialog" persistent max-width="1600" scrollable>
        <v-card>
          <v-card-title>
            <span class="text-h5">{{ dialog_title }}</span>
          </v-card-title>
          <v-form ref="form" v-model="form_valid" lazy-validation>
            <v-card-text>
              <v-container>
                <v-row>
                  <!-- email -->
                  <v-col cols="12" md="3">
                    <v-text-field
                      max-length="120"
                      v-model="cur_member.email"
                      label="Email"
                      required
                      :rules="emailRules"
                    ></v-text-field>
                  </v-col>
                  <!-- first name -->
                  <v-col cols="12" md="3">
                    <v-text-field
                      label="First Name"
                      v-model="cur_member.first_name"
                      required
                      :rules="nameRules"
                    ></v-text-field>
                  </v-col>
                  <!-- last name -->
                  <v-col cols="12" md="3">
                    <v-text-field
                      label="Last Name"
                      v-model="cur_member.last_name"
                      required
                      :rules="nameRules"
                    ></v-text-field>
                  </v-col>
                  <!-- last name -->
                  <v-col cols="12" md="3">
                    <v-text-field
                      label="RPD #"
                      v-model="cur_member.rpd_number"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <!-- division -->
                  <v-col cols="12" md="3">
                    <v-text-field
                      label="Division"
                      v-model="cur_member.division"
                    ></v-text-field>
                  </v-col>
                  <!-- status -->
                  <v-col cols="12" md="3">
                    <v-select
                      v-model="cur_member.status"
                      :items="['New', 'Assigned', 'Certified']"
                      label="Status"
                      required
                    ></v-select>
                  </v-col>
                  <!-- assigned -->
                  <v-col cols="12" md="3">
                    <v-text-field
                      label="Assigned Test"
                      v-mask="'##/##/####'"
                      placeholder="##/##/####"
                      v-model="cur_member.assigned"
                      hint="Date"
                      required
                      :rules="dateRules"
                    ></v-text-field>
                  </v-col>
                  <!-- cert_date -->
                  <v-col cols="12" md="3">
                    <v-text-field
                      label="Certified"
                      v-mask="'##/##/####'"
                      placeholder="##/##/####"
                      v-model="cur_member.cert_date"
                      hint="Date"
                      required
                      :rules="dateRules"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <!-- exp_date -->
                  <v-col cols="12" md="3">
                    <v-text-field
                      label="Expiration"
                      v-mask="'##/##/####'"
                      placeholder="##/##/####"
                      v-model="cur_member.exp_date"
                      hint="Date"
                      required
                      :rules="dateRules"
                    ></v-text-field>
                  </v-col>
                  <!-- last email -->
                  <v-col cols="12" md="3">
                    <v-text-field
                      label="Last Email"
                      v-model="cur_member.lastemail"
                      disabled
                      required
                    ></v-text-field>
                  </v-col>
                  <!-- last score -->
                  <v-col cols="12" md="3">
                    <v-text-field
                      label="Last Score"
                      v-model="cur_member.last_score"
                      disabled
                      required
                    ></v-text-field>
                  </v-col>
                  <!-- modified -->
                  <v-col cols="12" md="3">
                    <v-text-field
                      label="Modified"
                      v-model="cur_member.s_date"
                      disabled
                      required
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" md="12">
                    <label>Notes</label>
                    <v-textarea
                      v-model="cur_member.note"
                      solo
                      hint="Type any notes you may need above here"
                    ></v-textarea>
                  </v-col>
                </v-row>
              </v-container>
              <small>Use 01/01/1900 for inital dates </small>
            </v-card-text>
          </v-form>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              v-if="dialog_title != 'Add Member'"
              color="grey darken-1 pr-4 mr-8"
              style="margin-right: 16px"
              text
              @click="delete_member"
            >
              Delete
            </v-btn>
            <v-btn color="blue darken-1" text @click="save_member">
              Save
            </v-btn>
            <v-btn color="blue darken-1" text @click="dialog = false">
              Close
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <v-row justify="center">
      <v-dialog v-model="email_form" persistent max-width="1600" scrollable>
        <v-card>
          <v-card-title>
            <span class="text-h5">Send Emails</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <!-- email -->
                <v-col cols="12" md="12">
                  <v-text-field
                    max-length="120"
                    v-model="email_data.to_address"
                    label="To:"
                    required
                    :rules="to_rules"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <!-- other_recipient -->
                <v-col cols="12" md="12">
                  <v-text-field
                    max-length="120"
                    v-model="email_data.other_recipient"
                    label="Other Recipient"
                    :rules="emailRules"
                  ></v-text-field>
                </v-col>
              </v-row>
              <!-- subject -->
              <v-row>
                <v-col cols="12" md="12">
                  <v-text-field
                    max-length="120"
                    v-model="email_data.subject"
                    label="Subject:"
                    required
                    :rules="subject_rules"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="12">
                  <label>Notes</label>
                  <v-textarea
                    v-model="email_data.body"
                    solo
                    hint="Change the email body as needed."
                  ></v-textarea>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn color="blue darken-1" text @click="email_cur_items_now">
              Send Email
            </v-btn>
            <v-btn color="blue darken-1" text @click="email_form = false">
              Close
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <!-- END sworn dialog -->
  </div>
</template>

<style lang="scss" scoped>
@import "../scss/site.scss";
.alice {
  color: aliceblue;
}
.btn-on {
  color: plum !important;
  border: 2px solid rgb(239, 11, 239) !important;
  background-color: rgb(0, 0, 0) !important;
}
// controls filter button wrap
.v-item-group {
  flex-wrap: wrap !important;
}
.v-card__title {
  padding: 0;
}

// .results .v-expansion-panel-content::v-deep .v-expansion-panel-content__wrap {
//   padding: 0 7px !important;
// }
.v-data-table::v-deep .v-data-footer .v-data-footer__select {
  visibility: hidden;
}
</style>

<script>
/* eslint-disable */
import { Certificate } from "crypto";
import { bus_common } from "../mixins/bus_common";
// import { setTimeout } from "timers/promises";
export default {
  name: "sworn",
  mixins: [bus_common],
  data() {
    // Status, Fname, Lnprivateame, DOB, DIVISION
    return {
      form_valid: true,
      update_ready: false,
      email_to_list: [],
      email_data: {
        subject: "NIBRS Certification Required",
        to_address: "",
        other_recipient: "",
        body: `Hello.
 Per the NIBRS Security Policy,  NIBRS  certification needs to be completed every two (2) years.  In order to comply with this policy, you will need to complete the testing via the RPD NIBRS  Sworn test at
 https://nibrs-test-swrn.renopd.com/.
 Once finished, I'll be notified electronically and will update your certification date.

 Note: In Section 2 of the questions, some questions have a link to refresher content.  After you review the refresher content, you can use the CLOSE button in the upper right to return to the test question.

 Thank you,
Lynn La Vanway
 lavanwayl@reno.gov`,
      },
      email_form: false,
      dialog_title: "Add Member",
      dialog: false,
      current_items: [],
      members: [],
      members_orig: [],
      search: "",
      toggle_exclusive: undefined,
      new_member: {
        sworn_memberId: 0,
        last_name: "",
        first_name: "",
        email: "",
        rpd_number: "",
        division: "",
        status: "",
        cert_date: "01/01/1900",
        exp_date: "01/01/1900",
        assigned: "01/01/1900",
        note: "",
        last_score: "",
      },
      cur_member: {
        sworn_memberId: 0,
        last_name: "",
        first_name: "",
        email: "",
        rpd_number: "",
        division: "",
        status: "New",
        cert_date: "1/1/1900",
        exp_date: "1/1/1900",
        assigned: "1/1/1900",
        note: "",
        last_score: "",
      },
      headers: [
        { text: "", value: "action1", sortable: false },
        // { text: "", value: "action2" },
        { text: "id", value: "sworn_memberId", align: " d-none" },
        {
          text: "Last",
          align: "start",
          value: "last_name",
        },
        { text: "First", value: "first_name" },
        { text: "Email", value: "email" },
        { text: "RPD#", value: "rpd_number" },
        { text: "Status", value: "status" },
        { text: "Certified", value: "cert_date" },
        { text: "Expires", value: "exp_date" },
        { text: "Assigned", value: "assigned" },
        { text: "Email Sent", value: "lastemail" },
        { text: "Division", value: "division", width: "95px" },
        { text: "Modified", value: "s_date" },
      ],

      nameRules: [
        (v) => !!v || "Name is required",
        (v) => v.length <= 60 || "Name must be less than 60 characters",
      ],
      dateRules: [(v) => !!v || "Date is required"],
      emailRules: [
        (v) =>
          /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
          "E-mail must be valid",
      ],
      to_rules: [(v) => !!v || "At least one valid email address is required."],
      subject_rules: [(v) => !!v || "At Subject is required."],
    };
  },
  methods: {
    message1() {
      alert("This button does nothing yet.");
    },
    print() {
      var ids = "";
      var arr_ids = [];
      for (let index = 0; index < this.current_items.length; index++) {
        const mem = this.current_items[index];
        arr_ids.push(mem.sworn_memberId);
      }
      ids = arr_ids.join("|");
      window.open("/print?ids=" + ids);
    },
    certify_sworn() {
      let self = this;
      this.swall_diag(
        "Confirm Certify Members",
        "Do you wish to certify '" +
          this.current_items.length +
          "' member(s) ?",
        "question",
        function () {
          //do it
          self.certify_sworn_now();
        },
        null,
        null,
        function () {}
      );
    },
    certify_sworn_now() {
      this.show_loader(true);
      var formIn = {};
      formIn.email = this.$store.state.user.email;
      formIn.token = this.$store.state.user.token;
      let lst_sworn_memberIds = [];
      for (let index = 0; index < this.current_items.length; index++) {
        const mem = this.current_items[index];
        lst_sworn_memberIds.push(mem.sworn_memberId);
      }

      formIn.lst_sworn_memberIds = lst_sworn_memberIds;

      formIn.apiname = "certify_sworn_now";
      var self = this;
      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          self.getSwornMembers();
          self.show_loader(false);
        })
        .catch((msg) => {
          this.show_loader(false);
          this.swall_it("Error", msg, "error", null, null);
        });
    },
    email_form_show() {
      this.email_data.to_address = "";
      for (let index = 0; index < this.current_items.length; index++) {
        const mem = this.current_items[index];
        this.email_data.to_address += mem.email + ", ";
      }
      this.email_data.to_address = this.email_data.to_address.slice(0, -2);
      this.email_form = true;
    },
    email_cur_items_now() {
      this.show_loader(true);
      var formIn = {};
      formIn.email = this.$store.state.user.email;
      formIn.token = this.$store.state.user.token;
      formIn.email_data = this.email_data;
      let lst_sworn_memberIds = [];
      for (let index = 0; index < this.current_items.length; index++) {
        const mem = this.current_items[index];
        lst_sworn_memberIds.push(mem.sworn_memberId);
      }

      formIn.lst_sworn_memberIds = lst_sworn_memberIds;

      formIn.apiname = "email_cur_items_now";
      var self = this;
      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          self.email_form = false;
          self.getSwornMembers();
          self.show_loader(false);
          this.swall_it(
            "Email Status",
            "Sent. (not in testing mode)",
            "success",
            null,
            null
          );
        })
        .catch((msg) => {
          this.show_loader(false);
          this.swall_it("Error", msg, "error", null, null);
        });
    },
    email_cur_items() {
      let self = this;
      this.swall_diag(
        "Confirm Email Group",
        "Do you wish to send an email to '" +
          this.current_items.length +
          "' member(s) ?",
        "question",
        function () {
          //do it
          self.email_form_show();
        },
        null,
        null,
        function () {}
      );
    },
    assign_tests_now() {
      this.show_loader(true);
      var formIn = {};
      formIn.email = this.$store.state.user.email;
      formIn.token = this.$store.state.user.token;
      let lst_sworn_memberIds = [];
      for (let index = 0; index < this.current_items.length; index++) {
        const mem = this.current_items[index];
        lst_sworn_memberIds.push(mem.sworn_memberId);
      }

      formIn.lst_sworn_memberIds = lst_sworn_memberIds;

      formIn.apiname = "assign_tests_now";
      var self = this;
      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          self.getSwornMembers();
          self.show_loader(false);
        })
        .catch((msg) => {
          this.show_loader(false);
          this.swall_it("Error", msg, "error", null, null);
        });
    },
    assign_tests() {
      let self = this;
      this.swall_diag(
        "Confirm Assign Tests",
        "Do you wish to assign test(s) to '" +
          this.current_items.length +
          "' member(s) ?",
        "question",
        function () {
          //do it
          self.assign_tests_now();
        },
        null,
        null,
        function () {}
      );
    },
    delete_member_now() {
      this.show_loader(true);
      var formIn = {};
      formIn.email = this.$store.state.user.email;
      formIn.token = this.$store.state.user.token;
      formIn.sworn_memberId = this.cur_member.sworn_memberId;

      formIn.apiname = "delete_member_now";
      var self = this;
      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          self.getSwornMembers();
          self.show_loader(false);
          self.dialog = false;
          this.swall_it("Delete Status", "Completed", "success", null, null);
        })
        .catch((msg) => {
          self.dialog = false;
          this.show_loader(false);
          this.swall_it("Error", msg, "error", null, null);
        });
    },
    delete_member() {
      let self = this;
      this.swall_diag(
        "Confirm Delete Memeber",
        "Do you wish to delete member '" +
          this.cur_member.first_name +
          " " +
          this.cur_member.last_name +
          "' ?",
        "question",
        function () {
          //do it
          self.delete_member_now();
        },
        null,
        null,
        function () {}
      );
    },
    remove_member_temp(member) {
      //this.members
      //sworn_memberId
      var indx = this.members.findIndex(
        (obj) => obj.sworn_memberId == member.sworn_memberId
      );
      if (indx != -1) {
        this.members.splice(indx, 1);
      }
      // var indx2 = this.current_items.findIndex((obj) => obj.sworn_memberId);
      // if (indx2 != -1) {
      //   this.current_items.splice(indx, 1);
      // }
    },
    edit_member(member) {
      this.dialog_title = "Edit Member";
      this.cur_member = this.mno(member);
      this.dialog = true;
    },
    isDate(datex) {
      // ^(0?[1-9]|[12][0-9]|3[01])[\/\-](0?[1-9]|1[012])[\/\-]\d{4}$
      //checks string format dd/mm/yyyy
      var reg = new RegExp("[0-9]{2}[-|\/]{1}[0-9]{2}[-|\/]{1}[0-9]{4}");
      if (!reg.test(datex)) {
        return false;
      }
      return new Date(datex) !== "Invalid Date" && !isNaN(new Date(datex));
    },
    save_member() {
      if (this.$refs.form.validate() == false) {
        this.swall_it(
          "Save Status",
          "Please correct the required fields.",
          "warning",
          null,
          null
        );
        return true;
      }
      if (
        !this.isDate(this.cur_member.assigned) ||
        !this.isDate(this.cur_member.cert_date) ||
        !this.isDate(this.cur_member.exp_date)
      ) {
        this.swall_it(
          "Save Status",
          "Some date fields have invalid dates. Please correct.",
          "warning",
          null,
          null
        );
        return true;
      }
      this.show_loader(true);
      var formIn = {};
      formIn.email = this.$store.state.user.email;
      formIn.token = this.$store.state.user.token;
      formIn.cur_member = this.mno(this.cur_member);

      formIn.apiname = "save_member";
      var self = this;
      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          self.getSwornMembers();
          self.show_loader(false);
          self.dialog = false;
          this.swall_it("Save Status", "Completed", "success", null, null);
        })
        .catch((msg) => {
          self.dialog = false;
          this.show_loader(false);
          this.swall_it(
            "Problem Saving Record",
            msg.msg,
            "warning",
            null,
            null
          );
        });
    },
    open_dialog() {
      this.dialog_title = "Add Member";
      this.cur_member = this.mno(this.new_member);
      this.dialog = true;
    },
    current_items_change(items) {
      //   if (this.search == "") {
      if (this.update_ready) {
        let itemsFiltered = this.$refs.my_table.$children[0].filteredItems;
        let lengthFiltered = itemsFiltered.length;
        this.current_items = this.mno(itemsFiltered);
        console.log(lengthFiltered);
      } else {
        console.log("ok then");
      }
    },
    filter_change(filter) {
      //clear any table search
      this.search = "";
      let self = this;
      let start_month = new this.$moment().startOf("month");
      let end_month = new this.$moment().endOf("month");
      let old_date = this.$moment("1/1/1900");
      self.members = this.mno(self.members_orig);

      switch (filter) {
        case "none":
          self.members = this.mno(self.members_orig);

          break;
        case "certified":
          this.members = this.members.filter((obj) => {
            if (!self.$moment(obj.cert_date).isSame(old_date)) {
              return obj;
            }
          });
          // code block
          break;
        case "this_month":
          this.members = this.members.filter((obj) => {
            if (self.$moment(obj.exp_date).isBetween(start_month, end_month)) {
              return obj;
            }
          });
          // code block
          break;
        case "next_month":
          // code block

          let st_plus = new this.$moment().startOf("month");
          let end_plus = new this.$moment().endOf("month");
          st_plus.add(1, "M");
          end_plus.add(1, "M");
          this.members = this.members.filter((obj) => {
            if (self.$moment(obj.exp_date).isBetween(st_plus, end_plus)) {
              return obj;
            }
          });

          break;
        case "assigned":
          // code block

          this.members = this.members.filter((obj) => {
            if (!self.$moment(obj.assigned).isSame(old_date)) {
              return obj;
            }
          });
          break;

        case "expired":
          // code block
          // code block
          //moment('2010-10-20').isAfter('2010-10-19')
          this.members = this.members.filter((obj) => {
            if (self.$moment().isAfter(self.$moment(obj.exp_date))) {
              return obj;
            }
          });
          // for (let index = 0; index < self.members_orig.length; index++) {
          //   const member = self.members_orig[index];
          //   if (member.exp_date.toString() == "01/01/1900") {
          //     self.members.push(member);
          //   }
          // }
          console.log(self.members.length);
          break;

        case "alpha20":
          // code block
          //20 but whatever number is wanbted
          var take = 20;
          try {
            this.members = this.members.filter((obj) => {
              if (self.$moment().isAfter(self.$moment(obj.exp_date))) {
                return obj;
              }
            });

            for (let index = 0; index < self.members_orig.length; index++) {
              const member = self.members_orig[index];
              //check to see if already added
              var mindex = self.members.findIndex(
                (obj) => obj.record_memberId == member.sworn_memberId
              );
              if (mindex == -1) {
                //not added

                if (member.exp_date.toString() == "01/01/1900") {
                  self.members.push(member);
                }
              }
            }

            this.members = this.members.filter((obj) => {
              if (obj.status != "Assigned") {
                return obj;
              }
            });

            self.members.sort((a, b) => a.last_name.localeCompare(b.last_name));

            self.members = self.members.slice(0, take);
          } catch (error) {
            console.log(error);
          }
          break;
          //also get all the 1/1/1900
          // let empt_date = new Date("1/1/1900");tot
          // for (let index = 0; index < this.members.length; index++) {
          //   const obj = this.members[index];

          //   if (obj.exp_date == empt_date) {
          //     this.members.push(obj);
          //   }
          // }
          break;
        case "past_due":
          let badmems = [];
          let nowdate = new Date();
          let empty_date = new Date("1/1/1900");
          for (let index = 0; index < this.members.length; index++) {
            const member = this.members[index];
            let past_due = new Date(member.assigned);
            past_due.setDate(past_due.getDate() + 30);
            // do not test empty dates, getTime transfrom the date to an integer
            if (new Date(member.assigned).getTime() != empty_date.getTime()) {
              if (nowdate > past_due) {
                badmems.push(member);
              }
            }
          }
          this.members = this.mno(badmems);

          break;
        case "pending":
          // code block
          let readymems = [];

          for (let index = 0; index < this.members.length; index++) {
            const member = this.members[index];
            ``;
            // do not test empty dates, getTime transfrom the date to an integer

            if (member.status === "Pending") {
              readymems.push(member);
            }
          }
          this.members = this.mno(readymems);
          break;
      }

      this.current_items = this.mno(this.members);
    },
    ready_now() {
      this.update_ready = true;
    },
    getSwornMembers() {
      this.show_loader(true);
      this.toggle_exclusive = 0;
      var formIn = {};
      formIn.email = this.$store.state.user.email;
      formIn.token = this.$store.state.user.token;
      formIn.apiname = "getSwornMembers";
      var self = this;
      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          self.members = this.mno(data);
          for (let index = 0; index < self.members.length; index++) {
            let member = self.members[index];
            member.email = member.email.trim();
            member.cert_date = self
              .$moment(member.cert_date)
              .format("MM/DD/YYYY");

            member.exp_date = self
              .$moment(member.exp_date)
              .format("MM/DD/YYYY");

            member.assigned = self
              .$moment(member.assigned)
              .format("MM/DD/YYYY");

            member.lastemail = self
              .$moment(member.lastemail)
              .format("MM/DD/YYYY");

            member.s_date = self.$moment(member.s_date).format("MM/DD/YYYY");
            //be able to restore filter
            self.members_orig = self.mno(self.members);
          }
          self.show_loader(false);
          this.ready_now();
        })
        .catch((msg) => {
          this.show_loader(false);
          this.swall_it("Error", msg, "error", null, null);
        });
    },
    init() {
      this.getSwornMembers();
    },
  },

  mounted() {
    this.$nextTick(() => {
      this.init();
    });
  },
};
</script>
